(() => {

  const loadCustomScripts = () => {
      window.custom_scripts.forEach(script => {
          let s = document.createElement('script');
          s.setAttribute('src', script);
          document.head.insertAdjacentElement("beforeend", s);
      });
  };

  const loadScripts = () => {
    loadCustomScripts();
  };

  document.addEventListener('UserInteracted', loadScripts, false);
})();